import { mediaCards } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            黑料视频专区
          </h2>
          <p className="text-sm text-foreground-500 mt-2">深度调查视频，还原事件真相</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaCards.map((card) => (
            <div
              key={card.id}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-[10px] font-bold rounded whitespace-nowrap">
                    {card.badge}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 flex items-center gap-3">
                  <span className="text-xs text-background-50/90 flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-time-line text-xs"></i>
                    {card.duration}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-background-50/90 rounded-full group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <div className="flex items-center gap-2 mt-2">
                  <i className="ri-eye-line text-xs text-foreground-400"></i>
                  <span className="text-xs text-foreground-400">{card.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}